// Removes readonly from form inputs so native HTML5 constraint validation runs on submit.
export const unlockReadonlyInputs = (form: HTMLFormElement): void => {
  form.querySelectorAll('input[readonly]').forEach((node) => {
    (node as HTMLInputElement).readOnly = false;
  });
};

// Runs native browser validation and shows the first invalid field tooltip when invalid.
export const reportNativeFormValidity = (form: HTMLFormElement): boolean => {
  unlockReadonlyInputs(form);

  if (form.checkValidity()) {
    return true;
  }

  form.reportValidity();
  return false;
};
